import styled from 'styled-components';
export const TableBodyWithScroll = styled.tbody `
  width: 100%;
  overflow: auto;
  display: inline-block;
  //scrollbar-color: #ffffff #0C0C0C;
  ::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: #0c0c0c;
    border-radius: 100px;
  }
`;
// new styles
export const TableBodyWithScrollNew = styled.tbody `
  width: 100%;
  overflow: auto;
  display: block;
  &::-webkit-scrollbar {
    width: 0px !important;
  }
`;
export const TableBodyWithScrollModal = styled.tbody `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100vw - 100px);
  max-width: 668px;
  max-height: 40vh;
  left: -30px;
  overflow-y: scroll;
  overflow-x: visible;
  position: relative;
  &::-webkit-scrollbar {
    width: 0px !important;
  }
`;
